<template>
  <MarketCard class="market-insights">
    <CardHeader :eventId="eventId" />

    <EventName
      :class="[classes.eventName, 'event-name']"
      :marketId="marketId"
      :eventId="eventId"
      :useTeamNames="true"
    />

    <div :class="[classes.promoWrapper]">
      <PromoFittedText
        :promoText="insightText"
        alignment="center"
        justifyContent="center"
      ></PromoFittedText>
    </div>

    <MarketName :class="classes.marketName" :marketId="marketId" />

    <div :class="classes.oddsButtonWrapper">
      <template v-if="relevantOption">
        <RelevantButton
          :class="[classes.oddsButton]"
          :option="relevantOption"
          :eventId="eventId"
        />
      </template>
      <template v-else>
        <Button
          :stagger="0"
          :class="[classes.oddsButton]"
          :option="firstOption"
        />
        <Button
          :stagger="2"
          :class="[classes.oddsButton]"
          :option="secondOption"
        />
      </template>
    </div>
  </MarketCard>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import MarketCard from "../../../styled/MarketCard.vue";
import CardHeader from "../../../CardHeader.vue";
import EventName from "../../../EventNameBadges.vue";
import PromoFittedText from "../../../PromoFittedText.vue";
import Button from "../Button.vue";
import { createUseStyles } from "@fresh8/ad-data-composition/src/theme";
import { injectCarouselContext } from "../../../../lib/provideInjectors";
import MarketName from "../../../MarketName.vue";
import { useInsightData } from "../../../../hooks/useInsightData";
import RelevantButton from "../RelevantButton.vue";

const { useStyles } = createUseStyles({
  marketName: {
    fontSize: "10px",
    textAlign: "center",
    marginTop: "4px"
  },
  eventName: {
    alignSelf: "center",
    margin: "8px 0",

    "& .competitors .banner": {
      maxWidth: "180px",
      "&.right": {
        marginLeft: props => (props.isCarousel ? "0" : "15px"),
        paddingRight: "8px"
      },
      "&.left": {
        marginRight: props => (props.isCarousel ? "0" : "15px"),
        paddingLeft: "8px"
      }
    },

    "& .banner.left, & .banner.right": {
      alignSelf: "center"
    },
    "& .vs": {
      placeSelf: "center",
      width: "25px"
    }
  },
  promoWrapper: {
    flex: "1 1 0",
    minHeight: "0px",
    padding: "3px 10px 0 10px",
    overflow: "hidden",
    boxSizing: "border-box",
    flexDirection: "column",
    display: "flex"
  },
  promoLogo: {
    height: "22px",
    margin: "auto"
  },
  oddsButton: {
    flex: 1,
    height: "35px",
    "& .odds-text": {
      fontSize: "14px"
    },
    "&:first-of-type": {
      marginRight: "4px"
    },
    "&:last-of-type": {
      marginLeft: "4px"
    }
  },
  oddsButtonWrapper: {
    display: "flex",
    padding: "8px",
    paddingTop: "6px"
  },
  resize: {
    pointerEvents: "none",
    zIndex: -99
  }
});

export default defineComponent({
  name: "InsightCardBadges",
  components: {
    MarketCard,
    CardHeader,
    EventName,
    PromoFittedText,
    Button,
    MarketName,
    RelevantButton
  },
  props: {
    marketId: { type: String, required: true },
    eventId: { type: String, required: true }
  },
  setup(props) {
    const carouselContext = injectCarouselContext();
    const {
      insightText,
      firstOption,
      secondOption,
      relevantOption
    } = useInsightData(props.marketId);

    const reactiveStyles = computed(() => ({
      isCarousel: carouselContext.value.isCarousel
    }));

    const { classesRef } = useStyles(reactiveStyles);

    return {
      classes: classesRef,
      insightText,
      firstOption,
      secondOption,
      relevantOption
    };
  }
});
</script>
